export default __webpack_public_path__ + "static/media/question.e9873945.svg";